export enum TYPE_GRAPH {
  MULTISERIE = 'multiserie',
  SINGLESERIE = 'singleserie',
  COLUMNS = 'columns',
  LINE = 'line',
  BAR = 'bar'
}

export enum TYPE_CONVERT_UNIT {
  SECONDS_TO_DAYS = 'secondsToDays',
  CUSTOM_FORMAT = 'customFormat',
  FORMAT_VALUE = 'formatValue',
  DEFAULT = 'default'
}
